const map = {
	"./Admin/Admins/Create": [
		2860,
		[
			2860
		]
	],
	"./Admin/Admins/Create.jsx": [
		2860,
		[
			2860
		]
	],
	"./Admin/Admins/List": [
		1348,
		[
			1348
		]
	],
	"./Admin/Admins/List.jsx": [
		1348,
		[
			1348
		]
	],
	"./Admin/AffiliateRejectedMaterials/Create": [
		3613,
		[
			3613
		]
	],
	"./Admin/AffiliateRejectedMaterials/Create.jsx": [
		3613,
		[
			3613
		]
	],
	"./Admin/AffiliateRejectedMaterials/List": [
		4065,
		[
			4065
		]
	],
	"./Admin/AffiliateRejectedMaterials/List.jsx": [
		4065,
		[
			4065
		]
	],
	"./Admin/Affiliates/Create": [
		1368,
		[
			1368
		]
	],
	"./Admin/Affiliates/Create.jsx": [
		1368,
		[
			1368
		]
	],
	"./Admin/Affiliates/List": [
		6424,
		[
			6424
		]
	],
	"./Admin/Affiliates/List.jsx": [
		6424,
		[
			6424
		]
	],
	"./Admin/Announcements/Create": [
		7892,
		[
			7892
		]
	],
	"./Admin/Announcements/Create.jsx": [
		7892,
		[
			7892
		]
	],
	"./Admin/Announcements/List": [
		3836,
		[
			3836
		]
	],
	"./Admin/Announcements/List.jsx": [
		3836,
		[
			3836
		]
	],
	"./Admin/BatchRejectTypes/Create": [
		6192,
		[
			6192
		]
	],
	"./Admin/BatchRejectTypes/Create.jsx": [
		6192,
		[
			6192
		]
	],
	"./Admin/BatchRejectTypes/List": [
		7296,
		[
			7296
		]
	],
	"./Admin/BatchRejectTypes/List.jsx": [
		7296,
		[
			7296
		]
	],
	"./Admin/BinBags/List": [
		9686,
		[
			9686
		]
	],
	"./Admin/BinBags/List.jsx": [
		9686,
		[
			9686
		]
	],
	"./Admin/BinBox/List": [
		9666,
		[
			9666
		]
	],
	"./Admin/BinBox/List.jsx": [
		9666,
		[
			9666
		]
	],
	"./Admin/CollectionPointBagRequests/BagRequests": [
		9748,
		[]
	],
	"./Admin/CollectionPointBagRequests/BagRequests.jsx": [
		9748,
		[]
	],
	"./Admin/CollectionPointBagRequests/Create": [
		9026,
		[
			9026
		]
	],
	"./Admin/CollectionPointBagRequests/Create.jsx": [
		9026,
		[
			9026
		]
	],
	"./Admin/CollectionPointBagRequests/List": [
		1118,
		[
			1118
		]
	],
	"./Admin/CollectionPointBagRequests/List.jsx": [
		1118,
		[
			1118
		]
	],
	"./Admin/CollectionPoints/Create": [
		9875,
		[
			9875
		]
	],
	"./Admin/CollectionPoints/Create.jsx": [
		9875,
		[
			9875
		]
	],
	"./Admin/CollectionPoints/List": [
		2099,
		[
			2099
		]
	],
	"./Admin/CollectionPoints/List.jsx": [
		2099,
		[
			2099
		]
	],
	"./Admin/Contacts/List": [
		2365,
		[
			7196,
			2365
		]
	],
	"./Admin/Contacts/List.jsx": [
		2365,
		[
			7196,
			2365
		]
	],
	"./Admin/Contacts/Show": [
		5806,
		[
			5806
		]
	],
	"./Admin/Contacts/Show.jsx": [
		5806,
		[
			5806
		]
	],
	"./Admin/Dashboard": [
		3174,
		[
			4048,
			3174
		]
	],
	"./Admin/Dashboard/": [
		3174,
		[
			4048,
			3174
		]
	],
	"./Admin/Dashboard/Profile": [
		1089,
		[
			1089
		]
	],
	"./Admin/Dashboard/Profile.jsx": [
		1089,
		[
			1089
		]
	],
	"./Admin/Dashboard/SendMail": [
		2176,
		[
			9795
		]
	],
	"./Admin/Dashboard/SendMail.jsx": [
		2176,
		[
			9795
		]
	],
	"./Admin/Dashboard/index": [
		3174,
		[
			4048,
			3174
		]
	],
	"./Admin/Dashboard/index.jsx": [
		3174,
		[
			4048,
			3174
		]
	],
	"./Admin/Dispatches/Create": [
		4406,
		[
			4406
		]
	],
	"./Admin/Dispatches/Create.jsx": [
		4406,
		[
			4406
		]
	],
	"./Admin/Dispatches/List": [
		1546,
		[
			1546
		]
	],
	"./Admin/Dispatches/List.jsx": [
		1546,
		[
			1546
		]
	],
	"./Admin/Dispatches/Pallets": [
		7425,
		[
			7425
		]
	],
	"./Admin/Dispatches/Pallets.jsx": [
		7425,
		[
			7425
		]
	],
	"./Admin/Dispatches/Show": [
		9797,
		[
			9797
		]
	],
	"./Admin/Dispatches/Show.jsx": [
		9797,
		[
			9797
		]
	],
	"./Admin/Dispatches/Update": [
		3069,
		[
			3069
		]
	],
	"./Admin/Dispatches/Update.jsx": [
		3069,
		[
			3069
		]
	],
	"./Admin/FileUploads/Create": [
		2192,
		[
			2192
		]
	],
	"./Admin/FileUploads/Create.jsx": [
		2192,
		[
			2192
		]
	],
	"./Admin/FileUploads/List": [
		1312,
		[
			1312
		]
	],
	"./Admin/FileUploads/List.jsx": [
		1312,
		[
			1312
		]
	],
	"./Admin/Materials/Create": [
		7970,
		[
			7970
		]
	],
	"./Admin/Materials/Create.jsx": [
		7970,
		[
			7970
		]
	],
	"./Admin/Materials/List": [
		5646,
		[
			5646
		]
	],
	"./Admin/Materials/List.jsx": [
		5646,
		[
			5646
		]
	],
	"./Admin/MemberProducts/Create": [
		7934,
		[
			7934
		]
	],
	"./Admin/MemberProducts/Create.jsx": [
		7934,
		[
			7934
		]
	],
	"./Admin/MemberProducts/List": [
		402,
		[
			402
		]
	],
	"./Admin/MemberProducts/List.jsx": [
		402,
		[
			402
		]
	],
	"./Admin/Pickups/Accept": [
		1505,
		[]
	],
	"./Admin/Pickups/Accept.jsx": [
		1505,
		[]
	],
	"./Admin/Pickups/Create": [
		8381,
		[
			8381
		]
	],
	"./Admin/Pickups/Create.jsx": [
		8381,
		[
			8381
		]
	],
	"./Admin/Pickups/List": [
		3697,
		[
			3697
		]
	],
	"./Admin/Pickups/List.jsx": [
		3697,
		[
			3697
		]
	],
	"./Admin/Pickups/Pallets": [
		7204,
		[]
	],
	"./Admin/Pickups/Pallets.jsx": [
		7204,
		[]
	],
	"./Admin/ProjectBagDrops/Create": [
		2161,
		[
			2161
		]
	],
	"./Admin/ProjectBagDrops/Create.jsx": [
		2161,
		[
			2161
		]
	],
	"./Admin/ProjectBagDrops/List": [
		3741,
		[
			3741
		]
	],
	"./Admin/ProjectBagDrops/List.jsx": [
		3741,
		[
			3741
		]
	],
	"./Admin/ProjectBagDrops/MaterialTypes": [
		9795,
		[]
	],
	"./Admin/ProjectBagDrops/MaterialTypes.jsx": [
		9795,
		[]
	],
	"./Admin/Projects/Create": [
		5438,
		[
			5438
		]
	],
	"./Admin/Projects/Create.jsx": [
		5438,
		[
			5438
		]
	],
	"./Admin/Projects/List": [
		2674,
		[
			2674
		]
	],
	"./Admin/Projects/List.jsx": [
		2674,
		[
			2674
		]
	],
	"./Admin/Report/CollectionPointBagDistribution": [
		3024,
		[
			3024
		]
	],
	"./Admin/Report/CollectionPointBagDistribution.jsx": [
		3024,
		[
			3024
		]
	],
	"./Admin/Report/Project": [
		5847,
		[
			5847
		]
	],
	"./Admin/Report/Project.jsx": [
		5847,
		[
			5847
		]
	],
	"./Admin/Settings/Create": [
		1413,
		[
			1413
		]
	],
	"./Admin/Settings/Create.jsx": [
		1413,
		[
			1413
		]
	],
	"./Admin/Settings/List": [
		3049,
		[
			3049
		]
	],
	"./Admin/Settings/List.jsx": [
		3049,
		[
			3049
		]
	],
	"./Admin/Storages/Create": [
		562,
		[
			562
		]
	],
	"./Admin/Storages/Create.jsx": [
		562,
		[
			562
		]
	],
	"./Admin/Storages/List": [
		3550,
		[
			3550
		]
	],
	"./Admin/Storages/List.jsx": [
		3550,
		[
			3550
		]
	],
	"./Admin/Users/CollectionPoint": [
		7040,
		[]
	],
	"./Admin/Users/CollectionPoint.jsx": [
		7040,
		[]
	],
	"./Admin/Users/Create": [
		6016,
		[
			6016
		]
	],
	"./Admin/Users/Create.jsx": [
		6016,
		[
			6016
		]
	],
	"./Admin/Users/List": [
		5440,
		[
			5440
		]
	],
	"./Admin/Users/List.jsx": [
		5440,
		[
			5440
		]
	],
	"./Auth/ForgotPassword": [
		2716,
		[
			2716
		]
	],
	"./Auth/ForgotPassword.jsx": [
		2716,
		[
			2716
		]
	],
	"./Auth/Login": [
		5283,
		[
			5283
		]
	],
	"./Auth/Login.jsx": [
		5283,
		[
			5283
		]
	],
	"./Auth/ResetPassword": [
		1354,
		[
			1354
		]
	],
	"./Auth/ResetPassword.jsx": [
		1354,
		[
			1354
		]
	],
	"./Auth/VerifyEmail": [
		8925,
		[
			8925
		]
	],
	"./Auth/VerifyEmail.jsx": [
		8925,
		[
			8925
		]
	],
	"./Error": [
		6053,
		[
			6053
		]
	],
	"./Error.jsx": [
		6053,
		[
			6053
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5427;
module.exports = webpackAsyncContext;